import api from '@/apis/di/collectionAgencyAPI.js';
// import Crud from '@/stores/crudBase';
import Crud from '@/stores/crudBase.js';
var crud = new Crud('collectionAgency', api);

const state = {
  ...crud.state,
  _config: {
    table: 'income_organization',
    field: {
      key: 'id',
      code: 'code',
      name: 'name',
      quickFollow: 'active',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
